import MainBlock from "components/DesignSystem/LayoutBlocks/MainBlock";
import LoadingIndicator from "components/General/LoadingIndicator";
import React, { useCallback, useEffect, useRef } from "react";
import { useParams, useHistory } from "react-router-dom";
import { useAuth } from "hooks/Auth";
import { apiGet } from "helpers/Request";
import { transform as channelTransformer } from "schemas/Channel";
import { transform as entryTransformer } from "schemas/Entry";
import { toast } from "react-hot-toast";

export default function SettingPanelScreen(props) {
    const { uuid } = useParams();
    const auth = useAuth();
    const ref = useRef();
    const history = useHistory();

    const goTo = useCallback(
        (path) => {
            history.push(path);
        },
        [history]
    );

    useEffect(() => {
        if (ref.current) {
            return;
        }

        apiGet(`/v4/channel/${uuid}`, auth.publication)
            .then((resp) => {
                const channel = channelTransformer(resp);
                if (channel && channel.id) {
                    return channel;
                }
                throw new Error("Could not load channel information");
            })
            .then((channel) => {
                return apiGet(`/v4/entry/`, auth.publication, {
                    channel: channel.id,
                    per_page: 1,
                    order: "id",
                    direction: "desc",
                }).then((resp) => {
                    const entry = entryTransformer(resp);
                    if (entry.length === 1 && entry[0].id) {
                        return entry[0];
                    }
                    return null;
                });
            })
            .then((entry) => {
                ref.current = true;
                if (entry) {
                    goTo("/app/custom-content/entry/" + entry.uuid);
                    return;
                }

                goTo("/app/custom-content/entry/new?channel=" + uuid);
            })
            .catch((e) => {
                console.error(e);
                toast.error(
                    "Unable to load channel or entry data " + e.message
                );
            });

        return () => {
            ref.current = null;
        };
    }, [auth.publication, uuid, goTo]);

    return (
        <MainBlock>
            <LoadingIndicator />
        </MainBlock>
    );
}
